import { render, staticRenderFns } from "./StaffPermissions.vue?vue&type=template&id=4819cba4&scoped=true&"
import script from "./StaffPermissions.vue?vue&type=script&setup=true&lang=js&"
export * from "./StaffPermissions.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./StaffPermissions.vue?vue&type=style&index=0&id=4819cba4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4819cba4",
  null
  
)

export default component.exports